import { Clock, Lock } from "lucide-react";

// Recordatorio de cierre — SOLO indicador visual (sin notificaciones/correos).
// Calcula días restantes a partir de due_date (YYYY-MM-DD) para actividades
// PUBLICADAS. No modifica ninguna lógica de negocio del backend.
export const DeadlinePill = ({ dueDate, published, className = "" }) => {
  if (!published || !dueDate) return null;

  const today = new Date(); today.setHours(0, 0, 0, 0);
  const due = new Date(dueDate + "T00:00:00");
  const diffDays = Math.round((due - today) / (1000 * 60 * 60 * 24));
  const dueDisplay = due.toLocaleDateString("es-CL", { day: "2-digit", month: "2-digit", year: "numeric" });

  let label, cls;
  if (diffDays < 0) { label = "Actividad cerrada"; cls = "bg-slate-100 text-slate-500 border-slate-200"; }
  else if (diffDays === 0) { label = "Cierra hoy"; cls = "bg-rose-50 text-rose-700 border-rose-200"; }
  else if (diffDays <= 3) { label = `Quedan ${diffDays} día${diffDays === 1 ? "" : "s"}`; cls = "bg-amber-50 text-amber-800 border-amber-200"; }
  else { label = `Quedan ${diffDays} días`; cls = "bg-slate-50 text-slate-600 border-slate-200"; }

  const Icon = diffDays < 0 ? Lock : Clock;

  return (
    <span
      data-testid="activity-deadline-pill"
      className={`inline-flex items-center gap-1 text-[10px] font-bold px-2 py-1 rounded-full border ${cls} ${className}`}
      title={`Fecha de cierre: ${dueDisplay}`}
    >
      <Icon className="w-3 h-3" /> {label}
    </span>
  );
};
